var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFormat = function SvgFormat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.188 4.078h-2.954v-.703a1.547 1.547 0 0 0-1.546-1.547H7.312a1.547 1.547 0 0 0-1.546 1.547v.703H2.812a.984.984 0 0 0-.984.984v9a.984.984 0 0 0 .984.985h12.376a.984.984 0 0 0 .984-.985v-9a.984.984 0 0 0-.985-.984Zm-8.579-.703a.703.703 0 0 1 .704-.703h3.375a.703.703 0 0 1 .703.703v.703H6.609v-.703ZM2.813 4.922h12.374a.14.14 0 0 1 .141.14v5.204H2.672V5.062a.14.14 0 0 1 .14-.14Zm12.374 9.281H2.813a.14.14 0 0 1-.141-.14v-2.954h12.656v2.954a.14.14 0 0 1-.14.14Z",
    fill: "#595959"
  })));
};
export default SvgFormat;